import { useEffect, useState } from 'react';

/**
 * Custom hook to get the screen ratio (width/height) and update it on window resize.
 * @function useScreenRatio
 * @returns {number} The current screen ratio.
 */
export const useScreenRatio = (): number => {
  const [ratio, setRatio] = useState<number>(
    window.innerWidth / window.innerHeight,
  );

  useEffect(() => {
    const handleResize = () => {
      setRatio(window.innerWidth / window.innerHeight);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return ratio;
};
